import Objects from '../../../../store/bookable-objects/objects';

angular
    .module('festzelt-os.modules.bo')
    .factory('BoObjects', [
        '$injector',
        'BookableObject',
        ($injector, BookableObject) => new Objects(BookableObject, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/store/objects.js